import { render, staticRenderFns } from "./TabSimulacion.vue?vue&type=template&id=ebaa99fe&scoped=true&"
import script from "./TabSimulacion.vue?vue&type=script&lang=js&"
export * from "./TabSimulacion.vue?vue&type=script&lang=js&"
import style0 from "./TabSimulacion.vue?vue&type=style&index=0&id=ebaa99fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebaa99fe",
  null
  
)

export default component.exports